import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as insightsAPI from '@debbie/cortex/dist/api/insights.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useDownloadedReport } from '@debbie/cortex/dist/insights/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { errorNotification } from '../../utils/errors.js';
import Alert from '../Alert.js';
import Button from '../Button.js';
import DownloadCloud from '../Icons/DownloadCloud.js';
import Panel from '../Panel.js';
import PlaceholderLoader from '../PlaceholderLoader.js';
const OrderedReport = () => {
    const { id } = useParams();
    const lang = useSelector((s) => s.lang);
    const downloadLoadable = useDownloadedReport(id);
    const downloadMutation = useMutation(async () => {
        const { url } = await insightsAPI.getDownloadUrl(id);
        window.location.href = url;
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'any', lang.errorEntities.file);
        },
    });
    return (React.createElement("div", { style: { width: '300px', margin: '0 auto', textAlign: 'center' } },
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement(Panel, null,
            React.createElement("br", null),
            h.isError(downloadLoadable) && (React.createElement(Alert, { message: downloadLoadable.error.message })),
            React.createElement("br", null),
            React.createElement(DownloadCloud, { style: { width: '100px', height: '100px' } }),
            h.isLoaded(downloadLoadable) && (React.createElement(React.Fragment, null,
                React.createElement("p", null, lang.insights.downloadsYourExportIsReady),
                React.createElement("p", { style: { fontWeight: 'bold', wordBreak: 'break-word' } }, downloadLoadable.data.file.fileName),
                React.createElement(Button, { onClick: () => downloadMutation.mutate(), loading: downloadMutation.isLoading }, lang.insights.downloadsYourExportIsReadyButton))),
            h.isLoading(downloadLoadable) && (React.createElement("p", null,
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(PlaceholderLoader, null))),
            React.createElement("br", null))));
};
export default OrderedReport;
//# sourceMappingURL=OrderedReport.js.map